import {MUTATION_KEYS} from '@/queryClient.ts'
import {useMutation} from '@tanstack/react-query'
import {AxiosError} from 'axios'
import {ErrorResponseData} from '@/types'
import {httpVerifyRecoveryToken} from './auth.http'

type UseVerifyRecoveryToken = {
    onSuccess?: () => void
    onError?: (error: AxiosError<ErrorResponseData>) => void
}

export const useVerifyRecoveryToken = (options?: UseVerifyRecoveryToken) =>
    useMutation({
        mutationKey: [MUTATION_KEYS.VERIFY_RECOVERY_TOKEN],
        mutationFn: httpVerifyRecoveryToken,
        onError: (error: AxiosError<ErrorResponseData>) => options?.onError?.(error),
        onSuccess: () => options?.onSuccess?.()
    })
